import type { HttpErrorResponse } from '@angular/common/http';

import type { PickActions } from '@recruitee/ngrx';
import { createSingleEntityStore, ngrxEvent } from '@recruitee/ngrx';

import type { SecureChangeParams } from './secure-change-http-client';

const { actions, reducer, namespace, selectors } = createSingleEntityStore<{
  secureChangeToken: string;
}>()('SecureChangeToken', {
  customActions: adapter => ({
    fetch: (state, payload: { params: SecureChangeParams; skipCompany: boolean }) =>
      adapter.markAsPending(state),

    requestEmailCode: ngrxEvent<void>(),
    requestEmailCodeSuccess: ngrxEvent<void>(),
    requestEmailCodeFailed: ngrxEvent<HttpErrorResponse>(),
  }),
});

const SecureChangeActions: PickActions<typeof actions, 'fetch' | 'requestEmailCode'> = actions;

export {
  SecureChangeActions,
  reducer as SecureChangeReducer,
  namespace as SecureChangeNamespace,
  selectors as SecureChangeSelectors,
};
